@if (open) {
  <div class="govco-alert-backdrop" aria-hidden="true"></div>
  <section class="govco-alert-modal" [class]="'govco-alert-modal ' + variant" role="alertdialog" aria-modal="true" aria-labelledby="govco-alert-title" aria-describedby="govco-alert-message">
    <span class="govco-alert-icon" aria-hidden="true">{{ icon }}</span>
    <h2 id="govco-alert-title">{{ title }}</h2>
    <p id="govco-alert-message">{{ message }}</p>
    <button type="button" class="btn-govco" (click)="closed.emit()">{{ actionLabel }}</button>
  </section>
}
